// extracted by mini-css-extract-plugin
export var activeFilterButton = "_jn-c";
export var backButton = "_jn-4";
export var backIcon = "_jn-5";
export var chevronShortcut = "_jn-6";
export var container = "_jn-1";
export var editor = "_jn-8";
export var editorWrapper = "_jn-7";
export var prefix = "_jn-2";
export var searchIcon = "_jn-3";
export var suffix = "_jn-9";
export var suffixContent = "_jn-a";
export var suffixText = "_jn-b";
export var wrapper = "_jn-0";